var map = {
	"./AuthConfig.auris.dev": 4355,
	"./AuthConfig.auris.dev.ts": 4355,
	"./AuthConfig.auris.local": 9840,
	"./AuthConfig.auris.local.ts": 9840,
	"./AuthConfig.auris.prod": 5072,
	"./AuthConfig.auris.prod.ts": 5072,
	"./AuthConfig.auris.qa": 2074,
	"./AuthConfig.auris.qa.ts": 2074,
	"./AuthConfig.elenia.dev": 2249,
	"./AuthConfig.elenia.dev.ts": 2249,
	"./AuthConfig.elenia.local": 4420,
	"./AuthConfig.elenia.local.ts": 4420,
	"./AuthConfig.elenia.prod": 132,
	"./AuthConfig.elenia.prod.ts": 132,
	"./AuthConfig.elenia.qa": 1983,
	"./AuthConfig.elenia.qa.ts": 1983,
	"./AuthConfig.jes.dev": 9113,
	"./AuthConfig.jes.dev.ts": 9113,
	"./AuthConfig.jes.local": 3793,
	"./AuthConfig.jes.local.ts": 3793,
	"./AuthConfig.jes.prod": 4111,
	"./AuthConfig.jes.prod.ts": 4111,
	"./AuthConfig.jes.qa": 4388,
	"./AuthConfig.jes.qa.ts": 4388,
	"./AuthConfig.loimua.dev": 4625,
	"./AuthConfig.loimua.dev.ts": 4625,
	"./AuthConfig.loimua.local": 8530,
	"./AuthConfig.loimua.local.ts": 8530,
	"./AuthConfig.loimua.prod": 1947,
	"./AuthConfig.loimua.prod.ts": 1947,
	"./AuthConfig.loimua.qa": 2298,
	"./AuthConfig.loimua.qa.ts": 2298,
	"./AuthConfig.nice.dev": 855,
	"./AuthConfig.nice.dev.ts": 855,
	"./AuthConfig.nice.local": 1131,
	"./AuthConfig.nice.local.ts": 1131,
	"./AuthConfig.nice.prod": 6141,
	"./AuthConfig.nice.prod.ts": 6141,
	"./AuthConfig.nice.qa": 9770,
	"./AuthConfig.nice.qa.ts": 9770,
	"./AuthConfig.ts": 3956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8638;